import React from "react";

import {
  FaUsers,
  FaCalendarAlt,
  FaEnvelope,
  FaMoneyBillWave,
  FaUserCheck,
  FaChartBar,
  FaAddressCard,
  FaCartPlus,
  FaRegCreditCard,
  FaUserCircle,
  FaFileSignature,
  FaRegNewspaper,
  FaImage,
  FaComment,
  FaHourglassHalf,
  FaCalculator,
  FaShoppingBag,
  FaReact,
  FaCommentMedical,
  FaVoteYea,
  FaDumbbell,
  FaBalanceScale,
  FaBullseye,
  FaFileInvoiceDollar,
} from "react-icons/fa";

import { IoMdContacts, IoMdSettings } from "react-icons/io";

import {
  GiBlackBelt,
  GiKimono,
  GiPodiumWinner,
  GiPodium,
  GiGong,
} from "react-icons/gi";

import {
  MdDashboard,
  MdTimer,
  MdOutlineInventory,
  MdBrowserUpdated,
} from "react-icons/md";

import { PiTranslateFill } from "react-icons/pi";
import { LuListTodo } from "react-icons/lu";
import { BsClipboardCheckFill } from "react-icons/bs";
import { RiQuestionnaireFill } from "react-icons/ri";
import { GrArticle } from "react-icons/gr";

export const DASHBOARD_BASE_PATH = "/dashboard";

export const ROLES = {
  ADMIN: 1,
  UTILISATEUR: 2,
  ENSEIGNANT: 3,
};

export const normalizePath = (path) =>
  String(path || "")
    .toLowerCase()
    .replace(/\/$/, "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

export const unwrapSettings = (settings) => {
  if (!settings) return {};

  let out = settings;

  if (Array.isArray(out)) out = out[0] || {};
  if (out && out.dataValues) out = out.dataValues;

  return out || {};
};

export const isTrue = (value) => {
  if (value === undefined || value === null) return false;
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value !== 0;

  if (typeof value === "string") {
    const v = value.trim().toLowerCase();

    return ["true", "1", "yes", "on"].includes(v);
  }

  return !!value;
};

export const getUserRoleId = (userOrRole) => {
  if (typeof userOrRole === "number") return userOrRole;
  if (typeof userOrRole === "string") return Number(userOrRole);

  return Number(
    userOrRole?.role_id ??
      userOrRole?.roleId ??
      userOrRole?.role?.id ??
      userOrRole?.role ??
      userOrRole?.user_role_id ??
      2,
  );
};

const makeDashboardPath = (classicPath) => {
  const cleanClassicPath = String(classicPath || "").startsWith("/")
    ? classicPath
    : `/${classicPath}`;

  return `${DASHBOARD_BASE_PATH}${cleanClassicPath}`;
};

const makeRoutePath = (classicPath) => {
  return String(classicPath || "").replace(/^\//, "");
};

const makeItem = ({
  title,
  classicPath,
  icon,
  displayKey = null,
  badge = null,
}) => {
  const dashboardPath = makeDashboardPath(classicPath);

  return {
    title,
    path: dashboardPath,
    dashboardPath,
    classicPath,
    routePath: makeRoutePath(classicPath),
    matchPaths: [dashboardPath],
    icon,
    displayKey,
    badge,
  };
};

export const DASHBOARD_MENU_SECTIONS = [
  {
    key: "utilisateur",
    label: "Utilisateur",
    color: "from-[#013E8E] to-indigo-600",
    allowedForRoles: [ROLES.ADMIN, ROLES.UTILISATEUR, ROLES.ENSEIGNANT],
    items: [
      makeItem({
        title: "Tableau de Bord",
        classicPath: "/tableau-de-bord",
        icon: <MdDashboard />,
      }),
      makeItem({
        title: "Dossier d'Inscription",
        classicPath: "/dossier-d-inscription",
        icon: <FaAddressCard />,
      }),
      makeItem({
        title: "Fiche Adhérent",
        classicPath: "/fiche-adherent",
        icon: <FaUserCircle />,
      }),
      makeItem({
        title: "Absences",
        classicPath: "/absences",
        icon: <FaCommentMedical />,
        displayKey: "display_absences",
      }),
      makeItem({
        title: "Calendrier",
        classicPath: "/calendrier",
        icon: <FaCalendarAlt />,
        displayKey: "display_calendrier",
      }),
      makeItem({
        title: "Messages",
        classicPath: "/messages",
        icon: <FaEnvelope />,
      }),
      makeItem({
        title: "Chat",
        classicPath: "/chat",
        icon: <FaComment />,
        displayKey: "display_chat",
      }),
      makeItem({
        title: "Boutique",
        classicPath: "/boutique",
        icon: <FaCartPlus />,
        displayKey: "display_boutique",
      }),
      makeItem({
        title: "Commandes & Règlements",
        classicPath: "/commandes-&-reglements",
        icon: <FaRegCreditCard />,
        displayKey: "display_commandes",
      }),
      makeItem({
        title: "Actualités",
        classicPath: "/actualites",
        icon: <FaRegNewspaper />,
        displayKey: "display_news",
      }),
      makeItem({
        title: "Galerie Photos",
        classicPath: "/galerie-photos",
        icon: <FaImage />,
        displayKey: "display_galerie",
      }),
      makeItem({
        title: "Lexique",
        classicPath: "/lexique",
        icon: <PiTranslateFill />,
        displayKey: "display_lexique",
      }),
      makeItem({
        title: "Arbitrage Judo",
        classicPath: "/arbitrage-judo",
        icon: <GiGong />,
        displayKey: "display_arbitrage",
      }),
      makeItem({
        title: "Applications Judo",
        classicPath: "/applications-judo",
        icon: <FaReact />,
        displayKey: "display_applications",
      }),
      makeItem({
        title: "Documents Passage Ceinture",
        classicPath: "/documents-passage-ceinture",
        icon: <GiBlackBelt />,
        displayKey: "display_passage_ceinture_documents",
      }),
      makeItem({
        title: "Prépa Physique",
        classicPath: "/prepa-physique",
        icon: <FaDumbbell />,
        displayKey: "display_prepa_physique",
      }),
      makeItem({
        title: "Techniques Judo",
        classicPath: "/techniques-judo",
        icon: <GiKimono />,
        displayKey: "display_techniques",
      }),
      makeItem({
        title: "Techniques Quizz",
        classicPath: "/techniques-quizz",
        icon: <GiKimono />,
        displayKey: "display_techniquesquizz",
      }),
      makeItem({
        title: "Vote Sondage Utilisateur",
        classicPath: "/vote-sondage-utilisateur",
        icon: <FaVoteYea />,
        displayKey: "display_vote",
      }),
    ],
  },

  {
    key: "enseignant",
    label: "Enseignant",
    color: "from-emerald-600 to-[#4CA82F]",
    allowedForRoles: [ROLES.ADMIN, ROLES.ENSEIGNANT],
    items: [
      makeItem({
        title: "Listing Adhérents",
        classicPath: "/listing-adherents",
        icon: <IoMdContacts />,
      }),
      makeItem({
        title: "Appel Présence",
        classicPath: "/appel-presence",
        icon: <FaUserCheck />,
        displayKey: "display_appels",
      }),
      makeItem({
        title: "Tableau Appel",
        classicPath: "/tableau-appel",
        icon: <BsClipboardCheckFill />,
        displayKey: "display_tableauappel",
      }),
      makeItem({
        title: "Passage Ceinture",
        classicPath: "/passage-ceinture",
        icon: <GiBlackBelt />,
        displayKey: "display_passage",
      }),
      makeItem({
        title: "Grade CN",
        classicPath: "/grade-cn",
        icon: <GiBlackBelt />,
        displayKey: "display_gradecn",
      }),
      makeItem({
        title: "Prépa Physique Coaching",
        classicPath: "/prepa-physique-coaching",
        icon: <FaDumbbell />,
        displayKey: "display_prepa_physique_coaching",
      }),
      makeItem({
        title: "Suivi Compétitions",
        classicPath: "/suivi-competitions",
        icon: <GiPodiumWinner />,
        displayKey: "display_suivicompetition",
      }),
      makeItem({
        title: "Événements",
        classicPath: "/evenements",
        icon: <FaCalendarAlt />,
        displayKey: "display_evenements",
      }),
      makeItem({
        title: "Palmarès",
        classicPath: "/palmares",
        icon: <GiPodium />,
        displayKey: "display_palmares",
      }),
      makeItem({
        title: "Objectifs",
        classicPath: "/objectifs",
        icon: <FaBullseye />,
        displayKey: "display_objectifs",
      }),
      makeItem({
        title: "ToDoList",
        classicPath: "/todolist",
        icon: <LuListTodo />,
        displayKey: "display_todolist",
      }),
      makeItem({
        title: "Techniques Enseignants",
        classicPath: "/techniques-enseignants",
        icon: <GiKimono />,
        displayKey: "display_techniquesenseignants",
      }),
      makeItem({
        title: "Catégories",
        classicPath: "/categories",
        icon: <FaBalanceScale />,
        displayKey: "display_categories",
      }),
      makeItem({
        title: "Fiche de frais",
        classicPath: "/fiche-de-frais",
        icon: <FaFileInvoiceDollar />,
        displayKey: "display_fichefrais",
      }),
      makeItem({
        title: "Aide Enseignants",
        classicPath: "/aide-enseignants",
        icon: <RiQuestionnaireFill />,
      }),
    ],
  },

  {
    key: "administrateur",
    label: "Administrateur",
    color: "from-slate-900 to-slate-700",
    allowedForRoles: [ROLES.ADMIN],
    items: [
      makeItem({
        title: "Dashboard Adhérents",
        classicPath: "/dashboard-adherents",
        icon: <FaChartBar />,
      }),
      makeItem({
        title: "Dashboard Comptabilité",
        classicPath: "/dashboard-comptabilite",
        icon: <FaChartBar />,
      }),
      makeItem({
        title: "Détails Adhérent",
        classicPath: "/details-adherent",
        icon: <FaUserCircle />,
      }),
      makeItem({
        title: "Listing Utilisateurs",
        classicPath: "/listing-utilisateurs",
        icon: <FaUsers />,
      }),
      makeItem({
        title: "Listing Adhérents Admin",
        classicPath: "/listing-adherents-admin",
        icon: <FaUsers />,
      }),
      makeItem({
        title: "Règlements Inscriptions",
        classicPath: "/reglements-inscriptions",
        icon: <FaMoneyBillWave />,
      }),
      makeItem({
        title: "Dossiers d'Inscription",
        classicPath: "/dossiers-d-inscription",
        icon: <FaFileSignature />,
      }),
      makeItem({
        title: "Paiements",
        classicPath: "/paiements",
        icon: <FaCartPlus />,
      }),
      makeItem({
        title: "Articles Admin",
        classicPath: "/articles-admin",
        icon: <FaShoppingBag />,
        displayKey: "display_articlesadmin",
      }),
      makeItem({
        title: "Dépenses Recettes",
        classicPath: "/depenses-recettes",
        icon: <FaCalculator />,
        displayKey: "display_depensesrecettes",
      }),
      makeItem({
        title: "Coachings",
        classicPath: "/coachings",
        icon: <MdTimer />,
        displayKey: "display_coaching",
      }),
      makeItem({
        title: "Heures Enseignement",
        classicPath: "/heures-enseignement",
        icon: <FaHourglassHalf />,
        displayKey: "display_heures_enseignants",
      }),
      makeItem({
        title: "Fiche de frais Admin",
        classicPath: "/fiche-de-frais-admin",
        icon: <FaFileInvoiceDollar />,
        displayKey: "display_fichefraisadmin",
      }),
      makeItem({
        title: "Inventaire",
        classicPath: "/inventaire",
        icon: <MdOutlineInventory />,
        displayKey: "display_inventaire",
      }),
      makeItem({
        title: "Prêt Matériel",
        classicPath: "/pret-materiel",
        icon: <GiKimono />,
        displayKey: "display_pretmateriel",
      }),
      makeItem({
        title: "Message Admin",
        classicPath: "/message-admin",
        icon: <FaEnvelope />,
        displayKey: "display_messages_admin",
      }),
      makeItem({
        title: "Vote Sondage Admin",
        classicPath: "/vote-sondage-admin",
        icon: <FaVoteYea />,
        displayKey: "display_voteadmin",
      }),
      makeItem({
        title: "Pages Personnalisées",
        classicPath: "/pages-personnalisees",
        icon: <GrArticle />,
        displayKey: "display_pagespersonnalisees",
      }),
      makeItem({
        title: "Paramètres",
        classicPath: "/parametres",
        icon: <IoMdSettings />,
      }),
      makeItem({
        title: "Requêtes Admin",
        classicPath: "/requetes-admin",
        icon: <RiQuestionnaireFill />,
      }),
      makeItem({
        title: "Abonnement",
        classicPath: "/abonnement",
        icon: <FaRegCreditCard />,
      }),
      makeItem({
        title: "Update",
        classicPath: "/update",
        icon: <MdBrowserUpdated />,
      }),
      makeItem({
        title: "Aide Conseils",
        classicPath: "/aide-conseils",
        icon: <RiQuestionnaireFill />,
      }),
    ],
  },
];

export function canSeeSection(section, userOrRole) {
  const roleId = getUserRoleId(userOrRole);

  return section.allowedForRoles.includes(roleId);
}

export function canSeeDashboardItem(item, settings) {
  const cleanSettings = unwrapSettings(settings);

  if (!item.displayKey) return true;

  return isTrue(cleanSettings[item.displayKey]);
}

export function getVisibleDashboardSections(userOrRole, settings) {
  return DASHBOARD_MENU_SECTIONS.map((section) => {
    if (!canSeeSection(section, userOrRole)) return null;

    const visibleItems = section.items.filter((item) =>
      canSeeDashboardItem(item, settings),
    );

    if (visibleItems.length === 0) return null;

    return {
      ...section,
      items: visibleItems,
    };
  }).filter(Boolean);
}

export function getAllDashboardItems(userOrRole = null, settings = null) {
  if (userOrRole) {
    return getVisibleDashboardSections(userOrRole, settings).flatMap(
      (section) => section.items,
    );
  }

  return DASHBOARD_MENU_SECTIONS.flatMap((section) => section.items);
}

export function isDashboardMenuActive(pathname, item) {
  const currentPath = normalizePath(pathname);

  return (item.matchPaths || [item.path]).some((basePath) => {
    const normalizedBase = normalizePath(basePath);

    return (
      currentPath === normalizedBase ||
      currentPath.startsWith(`${normalizedBase}/`) ||
      currentPath.startsWith(`${normalizedBase}?`)
    );
  });
}

export function getActiveDashboardItem(
  pathname,
  userOrRole = null,
  settings = null,
) {
  return getAllDashboardItems(userOrRole, settings).find((item) =>
    isDashboardMenuActive(pathname, item),
  );
}
